import {Component, Input} from '@angular/core';
import * as Moment from "moment";
import {extendMoment} from "moment-range";
const moment = extendMoment(Moment);

@Component({
  selector: 'gantt-group',
  templateUrl: './gantt-group.component.html',
  styleUrls: ['./gantt-group.component.css']
})
export class GanttGroupComponent {
  newGroups: any[];

  @Input() dataInicial: string = "2016-01-01";
  @Input() dataFinal: string = "2020-01-31";
  @Input() configEsc: {};
  @Input() data: any[] = [];
  @Input() lines: any[] = [];
  @Input() lineValue: string;
  @Input() dataInicialField: string;
  @Input() dataFinalField: string;
  @Input() captionField: string;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.changeArray(this.lines, this.lineValue, this.data, this.dataInicial,
      this.dataFinal, this.dataInicialField, this.dataFinalField)
  }

  changeArray(lines, lineValue, data, dataInicial, dataFinal, dataInicialField,
              dataFinalField): any {
    this.newGroups = lines.map((line) => {
      line["data"] = data.filter((data) => {
        let insideScope = moment(data[dataInicialField]).isBefore(dataFinal) ||
          moment(data[dataFinalField]).isAfter(dataInicial);
        return line[lineValue] == data[lineValue] && insideScope
      });
      return line
    });
  }
}
